import { DiagnosticInformationBase } from "./DiagnosticInformationBase";

export class DiagnosticInformation extends DiagnosticInformationBase {
}